/** Error messages of the API, translated per request. Part of `de`. */
export const server = {
  unauthenticated: 'Bitte anmelden',
  forbidden: 'Keine Berechtigung',
  notFound: 'Nicht gefunden',
  invalidInput: 'Eingaben sind ungültig',
  payloadTooLarge: 'Datenmenge zu groß',
  rateLimited: 'Zu viele Anfragen, bitte später erneut versuchen',
  badRequest: 'Ungültige Anfrage',
  internal: 'Interner Serverfehler',
  csrf: 'Anfrage ohne gültigen Schutz-Header abgelehnt',
  userNotFound: 'Benutzer nicht gefunden',
  priceCatalogNotFound: 'Preiskatalog nicht gefunden',
  priceCatalogDefault:
    'Der Standardkatalog bleibt bestehen – erst einen anderen Katalog zum Standard machen',
  emailTaken: 'E-Mail-Adresse ist bereits registriert',
  ownPasswordReset: 'Das eigene Passwort bitte über „Passwort ändern“ setzen',
  rejectOnlyPending: 'Nur nicht freigegebene Registrierungen können abgelehnt werden',
  ownAccount: 'Das eigene Konto kann hier nicht geändert werden',
  lastAdmin: 'Es muss mindestens ein aktiver Administrator bleiben',
  registrationDisabled: 'Registrierung ist deaktiviert',
  invalidAccessCode: 'Der Zugangscode ist falsch',
  invalidCredentials: 'E-Mail oder Passwort falsch',
  accountPending: 'Ihr Konto wartet noch auf die Freigabe durch den Administrator',
  wrongPassword: 'Das bisherige Passwort ist falsch',
  noFile: 'Keine Datei übermittelt',
  glbOnly: 'Bitte eine .glb-Datei hochladen',
  modelNotFound: 'Modell nicht gefunden',
  modelFileMissing: 'Modelldatei fehlt im Speicher',
  modelUnavailable: 'Modell existiert nicht oder ist nicht freigegeben',
  unknownModels: 'Projekt verweist auf unbekannte Modelle',
  projectNotFound: 'Projekt nicht gefunden',
  projectCorrupt: 'Gespeichertes Projekt ist beschädigt',
  projectIdMismatch: 'Projekt-ID passt nicht',
  /** Wraps the reason from reading the project, which is already a finished sentence. */
  documentRejected: '{detail}',
  projectChanged: 'Projekt wurde zwischenzeitlich geändert',
  versionNotFound: 'Version nicht gefunden',
  versionCorrupt: 'Gespeicherte Version ist beschädigt',
  saveBeforeReport: 'Bitte zuerst speichern – der Bericht wird aus dem gespeicherten Stand erzeugt',
  invalidReportImage: 'Ansicht „{title}“ ist kein gültiges Bild',
  invalidThumbnail: 'Das Vorschaubild ist ungültig',
  glbTooSmall: 'Datei ist zu klein für ein GLB-Modell',
  glbNoMagic: 'Keine gültige GLB-Datei (Kennung fehlt)',
  glbVersion: 'Nur glTF 2.0 wird unterstützt',
  glbTruncated: 'GLB-Datei ist unvollständig oder beschädigt',
  glbNoJson: 'GLB-Datei enthält keinen gültigen JSON-Block',
  glbBadJson: 'GLB-Datei enthält ungültiges JSON',
  glbExternal:
    'Externe Dateiverweise werden nicht unterstützt – bitte ein eigenständiges GLB exportieren',
  glbUnreadable: 'Modell konnte nicht gelesen werden: {detail}',
  glbNoScene: 'Modell enthält keine Szene',
  glbNoGeometry: 'Modell enthält keine sichtbare Geometrie',
  imageFormat: 'Bitte ein Bild im Format JPG oder PNG oder eine PDF-Zeichnung hochladen',
  imageSize: 'Die Bildgröße ist ungültig',
  imageTooLarge: 'Das Bild ist zu groß (höchstens {max} Pixel je Seite)',
  videoFormat: 'Bitte ein Video im Format MP4 oder WebM hochladen',
  videoTooLarge: 'Das Video ist zu groß (höchstens {max})',
  videoTooLong: 'Das Video ist zu lang (höchstens 15 Minuten)',
  videoQuota:
    'Der Speicherplatz für Videos ist voll ({used} von {quota} belegt). Bitte ältere Videos löschen.',
  videoNotFound: 'Video nicht gefunden',
  rangeInvalid: 'Ungültiger Bereich angefordert',
  readOnlyProject: 'Dieses Projekt ist für dich nur zur Ansicht freigegeben',
  ownerOnly: 'Das darf nur der Eigentümer des Projekts',
  memberUnknown: 'Unter dieser E-Mail-Adresse ist kein Benutzer registriert',
  memberIsOwner: 'Der Eigentümer hat ohnehin vollen Zugriff',
  memberNotFound: 'Diese Person hat keinen Zugriff auf das Projekt',
  chatMessageNotFound: 'Nachricht nicht gefunden',
  chatFileNotFound: 'Datei nicht gefunden',
  chatNotYours: 'Nur eigene Nachrichten können gelöscht werden',
  interpreterUnavailable: 'Für diese Sprachen ist kein Dolmetscher eingerichtet',
  interpreterFailed: 'Der Dolmetscher-Dienst ist gerade nicht erreichbar',
  dictationUnavailable: 'Diktieren ist auf diesem Server nicht eingerichtet',
  dictationFailed: 'Die Spracherkennung ist gerade nicht erreichbar, bitte erneut versuchen',
};

export type ServerMessages = typeof server;
